"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initForm = exports.isChineseDomain = void 0;
const smartlook_1 = require("../../build-babel/form/smartlook");
const login_1 = require("../../build-babel/form/login");
const sanitizer_1 = require("../../build-babel/form/sanitizer");
const forgotPassword_1 = require("../../build-babel/form/forgotPassword");
const captchaCode_1 = require("../../build-babel/form/captchaCode");
const config_1 = require("../../build-babel/auth/client/config");
const usStates_1 = require("./usStates");
const cookieBanner_1 = require("../../build-babel/cookieBanner");
const CH_DOMAINS = ['identity.hapag-lloyd.cn', 'identity-qa-cn.hlag.cloud', 'identity-dev-cn.hlag.cloud', 'www.hapag-lloyd.cn', 'wwwtest.hapag-lloyd.cn', 'wwwdeve.hapag-lloyd.cn'];
const isChineseDomain = () => CH_DOMAINS.indexOf(window.location.hostname) !== -1;
exports.isChineseDomain = isChineseDomain;
const isRegistrationPage = () => {
  if (document.getElementById('combinedLocation')) {
    return true;
  }
  const SUBMIT_BUTTON = document.querySelector("button[type='submit']#continue");
  if (!SUBMIT_BUTTON) {
    return false;
  }
  return getComputedStyle(SUBMIT_BUTTON).display !== 'none';
};
const isForgotPasswordPage = () => window.location.href.indexOf('claimsexchange=ForgotPasswordExchange') !== -1;
const isLoginPage = () => !!document.querySelector('a[id="createAccount"]');
const isFinalStepOfRegistration = () => !!document.querySelector('.extension_termsOfUseConsentChoice_li');
const script = document.createElement('script');
script.src = config_1.cloudflare.scriptSrc;
const emailVerificationContainer = document.querySelector('.emailVerificationControl_li .attrEntry');
const emailVerificationContent = emailVerificationContainer === null || emailVerificationContainer === void 0 ? void 0 : emailVerificationContainer.querySelector('#emailVerificationControl');
const emailFieldBox = emailVerificationContainer === null || emailVerificationContainer === void 0 ? void 0 : emailVerificationContainer.querySelector('.email_li');
const emailField = emailFieldBox === null || emailFieldBox === void 0 ? void 0 : emailFieldBox.querySelector('.attrEntry');
const isVerifyEmailAddress = () => {
  if (emailField) {
    const emailFieldProps = getComputedStyle(emailField);
    const display = emailFieldProps.getPropertyValue('display');
    if (display !== 'none') {
      return true;
    }
  }
  return false;
};
const useCustomerAccountType = () => {
  const jobTitle = document.querySelector('.jobTitle_li .attrEntry');
  const newsletterConsentCheckbox = document.querySelector('.extension_newsletterConsentChoice_li');
  const accountTypes = document.querySelectorAll('input[name="accountType"]');
  if (jobTitle && newsletterConsentCheckbox) {
    newsletterConsentCheckbox.style.display = 'list-item';
    jobTitle.style.display = 'block';
    accountTypes.forEach(accountType => {
      accountType.addEventListener('change', function (event) {
        const item = event.target;
        if (item.value === 'customer') {
          newsletterConsentCheckbox.style.display = 'list-item';
          jobTitle.style.display = 'block';
        } else {
          const selectJobTitle = jobTitle.querySelector('#jobTitle');
          selectJobTitle.value = 'other';
          jobTitle.style.display = 'none';
          newsletterConsentCheckbox.style.display = 'none';
        }
      });
    });
  }
};
const styleAccountTypeRadioButtons = () => {
  const accountTypes = document.querySelector('.accountType_li .attrEntry');
  if (accountTypes) {
    // Customer account type
    const customerAccountTypeContainer = document.createElement('div');
    customerAccountTypeContainer.style.display = 'flex';
    customerAccountTypeContainer.style.marginTop = '10px';
    const customerAccountTypeInput = accountTypes.querySelector('#accountType_customer');
    customerAccountTypeInput.style.width = '25px';
    customerAccountTypeInput.style.height = '15px';
    const customerAccountTypeLabel = accountTypes.querySelector('#customer_option');
    customerAccountTypeLabel.style.margin = '0px 5px';
    accountTypes.insertBefore(customerAccountTypeContainer, customerAccountTypeInput);
    customerAccountTypeContainer.appendChild(customerAccountTypeInput);
    customerAccountTypeContainer.appendChild(customerAccountTypeLabel);
    // Vendor account type
    const vendorAccountTypeContainer = document.createElement('div');
    vendorAccountTypeContainer.style.display = 'flex';
    vendorAccountTypeContainer.style.marginTop = '10px';
    const vendorAccountTypeInput = accountTypes.querySelector('#accountType_vendor');
    vendorAccountTypeInput.style.width = '25px';
    vendorAccountTypeInput.style.height = '15px';
    const vendorAccountTypeLabel = accountTypes.querySelector('#vendor_option');
    vendorAccountTypeLabel.style.margin = '0px 5px';
    accountTypes.insertBefore(vendorAccountTypeContainer, vendorAccountTypeInput);
    vendorAccountTypeContainer.appendChild(vendorAccountTypeInput);
    vendorAccountTypeContainer.appendChild(vendorAccountTypeLabel);
  }
};
const styleFederatedExchangeButton = () => {
  const federatedExchangeButton = document.getElementById('FederatedExchange');
  if (federatedExchangeButton) {
    federatedExchangeButton.innerText = 'Log in here';
    // create a label
    const federatedExchangeLabel = document.createElement('span');
    federatedExchangeLabel.innerText = 'Hapag-Lloyd employee?';
    const federatedExchangeElement = document.createElement('div');
    federatedExchangeElement.setAttribute('id', 'FederatedExchangeContainer');
    federatedExchangeElement.classList.add('divider');
    federatedExchangeElement.appendChild(federatedExchangeLabel);
    federatedExchangeElement.appendChild(federatedExchangeButton);
    // make a place
    document.querySelectorAll('#localAccountForm .divider').forEach(divider => divider.remove());
    // move
    const destination = document.getElementById('localAccountForm');
    destination === null || destination === void 0 ? void 0 : destination.appendChild(federatedExchangeElement);
    // remove
    const buttons = document.querySelector('.claims-provider-list-buttons');
    const nextElement = buttons === null || buttons === void 0 ? void 0 : buttons.nextElementSibling;
    nextElement && nextElement.remove();
    buttons && buttons.remove();
  }
};
const adjustAgreeOption = () => {
  (0, exports.isChineseDomain)() ? adjustAgreeOptionForChineseDomain() : adjustAgreeOptionForAllOtherDomains();
};
const adjustAgreeOptionForChineseDomain = () => {
  var _a, _b;
  const agreeLabel = document.getElementById('AgreeToTermsOfUseConsentYes_option');
  if (agreeLabel) {
    // create first span for 'I have read and agree to the '
    const agreeFirstSpanEnglish = document.createElement('span');
    agreeFirstSpanEnglish.innerText = 'I have read and aware of the ';
    agreeFirstSpanEnglish.setAttribute('class', 'label__agree');
    // create first span for 'I have read and agree to the '
    const agreeFirstSpanChinese = document.createElement('span');
    agreeFirstSpanChinese.innerText = '我已阅读并同意 ';
    agreeFirstSpanChinese.setAttribute('class', 'label__agree');
    // link to the Privacy Term
    const privacyTermsLinkEnglish = document.createElement('a');
    privacyTermsLinkEnglish.innerText = 'Privacy Terms';
    privacyTermsLinkEnglish.setAttribute('class', 'agree_link');
    privacyTermsLinkEnglish.setAttribute('href', 'https://www.hapag-lloyd.cn/en/meta/privacy-statement.html');
    privacyTermsLinkEnglish.setAttribute('target', '_blank');
    // link to the Privacy Term
    const privacyTermsLinkChinese = document.createElement('a');
    privacyTermsLinkChinese.innerText = '隐私条款';
    privacyTermsLinkChinese.setAttribute('class', 'agree_link');
    privacyTermsLinkChinese.setAttribute('href', 'https://www.hapag-lloyd.cn/zh/meta/privacy-statement.html');
    privacyTermsLinkChinese.setAttribute('target', '_blank');
    // create a second span for ' and '
    const agreeSecondSpanEnglish = document.createElement('span');
    agreeSecondSpanEnglish.innerText = ' and ';
    agreeSecondSpanEnglish.setAttribute('class', 'label__agree');
    // create a second span for ' and '
    const agreeSecondSpanChinese = document.createElement('span');
    agreeSecondSpanChinese.innerText = ' 和 ';
    agreeSecondSpanChinese.setAttribute('class', 'label__agree');
    // link to the Terms of Use
    const termsOfUseLinkEnglish = document.createElement('a');
    termsOfUseLinkEnglish.innerText = 'Terms of Use';
    termsOfUseLinkEnglish.setAttribute('class', 'agree_link');
    termsOfUseLinkEnglish.setAttribute('href', 'https://www.hapag-lloyd.cn/en/meta/legal-terms.html');
    termsOfUseLinkEnglish.setAttribute('target', '_blank');
    // link to the Terms of Use
    const termsOfUseLinkChinese = document.createElement('a');
    termsOfUseLinkChinese.innerText = '使用条款';
    termsOfUseLinkChinese.setAttribute('class', 'agree_link');
    termsOfUseLinkChinese.setAttribute('href', 'https://www.hapag-lloyd.cn/zh/meta/legal-terms.html');
    termsOfUseLinkChinese.setAttribute('target', '_blank');
    // create the third span for ' of the website.'
    const agreeThirdSpanEnglish = document.createElement('span');
    agreeThirdSpanEnglish.innerText = ', agree to Hapag-Lloyd, its affiliates, and authorized partners to collecting my personal data for reasonable business purposes connected to the above activity.';
    agreeThirdSpanEnglish.setAttribute('class', 'label__agree');
    // create the third span for ' of the website.'
    const agreeThirdSpanChinese = document.createElement('span');
    agreeThirdSpanChinese.innerText = '，同意赫伯罗特及其附属或关联公司和授权合作伙伴出于合理的商业目的在此处收集我的个人信息。';
    agreeThirdSpanChinese.setAttribute('class', 'label__agree');
    // create exchange english Div
    const agreeExchangeDivEnglish = document.createElement('div');
    agreeExchangeDivEnglish.appendChild(agreeFirstSpanEnglish);
    agreeExchangeDivEnglish.appendChild(privacyTermsLinkEnglish);
    agreeExchangeDivEnglish.appendChild(agreeSecondSpanEnglish);
    agreeExchangeDivEnglish.appendChild(termsOfUseLinkEnglish);
    agreeExchangeDivEnglish.appendChild(agreeThirdSpanEnglish);
    const agreeExchangeDivSpacing = document.createElement('div');
    agreeExchangeDivSpacing.setAttribute('style', 'height: 10px;');
    // create exchange english Div
    const agreeExchangeDivChinese = document.createElement('div');
    agreeExchangeDivChinese.appendChild(agreeFirstSpanChinese);
    agreeExchangeDivChinese.appendChild(privacyTermsLinkChinese);
    agreeExchangeDivChinese.appendChild(agreeSecondSpanChinese);
    agreeExchangeDivChinese.appendChild(termsOfUseLinkChinese);
    agreeExchangeDivChinese.appendChild(agreeThirdSpanChinese);
    // create exchange Label
    const agreeExchangeLabel = document.createElement('label');
    agreeExchangeLabel.setAttribute('id', 'agreeExchangeContainer');
    agreeExchangeLabel.setAttribute('for', 'extension_termsOfUseConsentChoice_AgreeToTermsOfUseConsentYes');
    agreeExchangeLabel.appendChild(agreeExchangeDivChinese);
    agreeExchangeLabel.appendChild(agreeExchangeDivSpacing);
    agreeExchangeLabel.appendChild(agreeExchangeDivEnglish);
    // replace the old agreeLabel with the new agreeExchangeLabel
    agreeLabel.replaceWith(agreeExchangeLabel);
    const secondErrorDiv = document.createElement('div');
    secondErrorDiv.setAttribute('id', 'second_tou_error');
    secondErrorDiv.setAttribute('class', 'error itemLevel');
    secondErrorDiv.setAttribute('role', 'alert');
    const secondInput = document.createElement('input');
    secondInput.setAttribute('type', 'checkbox');
    secondInput.setAttribute('id', 'extension_termsOfUseConsentChoiceSecond_AgreeToTermsOfUseConsentYes');
    const secondFirstSpanEnglish = document.createElement('span');
    secondFirstSpanEnglish.innerText = 'I agree that my data including personal information provided may be transferred and processed overseas due to business requirements connected to the above activity.';
    secondFirstSpanEnglish.setAttribute('class', 'label__agree');
    const secondFirstSpanChinese = document.createElement('span');
    secondFirstSpanChinese.innerText = '我同意此处提供的包括个人信息在内的数据因业务需要而跨境处理。';
    secondFirstSpanChinese.setAttribute('class', 'label__agree');
    const secondDivEnglish = document.createElement('div');
    secondDivEnglish.appendChild(secondFirstSpanEnglish);
    const secondDivSpacing = document.createElement('div');
    secondDivSpacing.setAttribute('style', 'height: 10px;');
    // create exchange english Div
    const secondDivChinese = document.createElement('div');
    secondDivChinese.appendChild(secondFirstSpanChinese);
    const secondLabel = document.createElement('label');
    secondLabel.setAttribute('id', 'agreeExchangeContainer');
    secondLabel.setAttribute('for', 'extension_termsOfUseConsentChoiceSecond_AgreeToTermsOfUseConsentYes');
    secondLabel.appendChild(secondDivChinese);
    secondLabel.appendChild(secondDivSpacing);
    secondLabel.appendChild(secondDivEnglish);
    const secondDiv = document.createElement('div');
    secondDiv.setAttribute('class', 'attrEntry validate');
    secondDiv.appendChild(secondErrorDiv);
    secondDiv.appendChild(secondInput);
    secondDiv.appendChild(secondLabel);
    const secondLi = document.createElement('li');
    secondLi.setAttribute('class', 'CheckboxMultiSelect extension_termsOfUseConsentChoiceSecond_li');
    secondLi.setAttribute('style', 'display: block;');
    secondLi.appendChild(secondDiv);
    const firstLi = (_a = agreeExchangeLabel.parentElement) === null || _a === void 0 ? void 0 : _a.parentElement;
    if (firstLi) {
      (_b = firstLi.parentElement) === null || _b === void 0 ? void 0 : _b.insertBefore(secondLi, firstLi.nextSibling);
    }
  }
};
const adjustAgreeOptionForAllOtherDomains = () => {
  const agreeLabel = document.getElementById('AgreeToTermsOfUseConsentYes_option');
  if (agreeLabel) {
    // create first span for terms of use
    const termsOfUseSpan = document.createElement('span');
    termsOfUseSpan.innerText = 'I have read and agree to the ';
    termsOfUseSpan.setAttribute('class', 'label__agree');
    // link to the Terms of Use
    const termsOfUseLink = document.createElement('a');
    termsOfUseLink.innerText = 'terms of use';
    termsOfUseLink.setAttribute('class', 'agree_link');
    termsOfUseLink.setAttribute('href', 'https://www.hapag-lloyd.com/en/meta/legal-terms.html');
    termsOfUseLink.setAttribute('target', '_blank');
    // create span for privacy terms
    const privacyTermsSpan = document.createElement('span');
    privacyTermsSpan.innerText = '. I have read the ';
    privacyTermsSpan.setAttribute('class', 'label__agree');
    // link to the Privacy Term
    const privacyTermsLink = document.createElement('a');
    privacyTermsLink.innerText = 'privacy terms';
    privacyTermsLink.setAttribute('class', 'agree_link');
    privacyTermsLink.setAttribute('href', 'https://www.hapag-lloyd.com/en/meta/privacy-statement.html');
    privacyTermsLink.setAttribute('target', '_blank');
    // create the third span with '.'
    const endingSpan = document.createElement('span');
    endingSpan.innerText = '.';
    endingSpan.setAttribute('class', 'label__agree');
    // create exchange Label
    const agreeExchangeLabel = document.createElement('label');
    agreeExchangeLabel.setAttribute('id', 'agreeExchangeContainer');
    agreeExchangeLabel.setAttribute('for', 'extension_termsOfUseConsentChoice_AgreeToTermsOfUseConsentYes');
    agreeExchangeLabel.appendChild(termsOfUseSpan);
    agreeExchangeLabel.appendChild(termsOfUseLink);
    agreeExchangeLabel.appendChild(privacyTermsSpan);
    agreeExchangeLabel.appendChild(privacyTermsLink);
    agreeExchangeLabel.appendChild(endingSpan);
    // replace the old agreeLabel with the new agreeExchangeLabel
    agreeLabel.replaceWith(agreeExchangeLabel);
  }
};
const styleEmailVerificationLabel = () => {
  const list = document.querySelector('.TextBox.VerificationCode_li.VerificationCode');
  const listElement = list === null || list === void 0 ? void 0 : list.firstChild;
  const listLabel = document.createElement('label');
  listLabel.setAttribute('id', 'verificationSuccessText_Label');
  listLabel.innerHTML = 'Check your email box and paste the code you received and click Verify code';
  if (listElement) {
    listElement.appendChild(listLabel);
  }
};
const fixTabIndexes = () => {
  const FORGOT_PASSWORD_LINK_ID = 'forgotPassword';
  const link = document.getElementById(FORGOT_PASSWORD_LINK_ID);
  if (link) {
    link.setAttribute('tabIndex', '-1');
  }
};
const fixCountryCodeStyle = () => {
  const countryCode = document.getElementById('inputCountryCode');
  if (countryCode) {
    countryCode.style.whiteSpace = 'initial';
  }
};
const randomizeUserRoles = () => {
  const userRolesSelect = document.getElementById('jobTitle');
  if (userRolesSelect) {
    const userRoles = userRolesSelect.options;
    const shuffledUserRoles = [...userRoles].sort(() => 0.5 - Math.random());
    shuffledUserRoles.forEach(shuffledUserRole => {
      userRolesSelect.options.add(shuffledUserRole);
    });
  }
};
const styleSecondStepOfRegistrationPage = () => {
  const emailVerificationMessage = document.getElementById('emailVerificationControl_success_message');
  if (emailVerificationMessage) {
    const emailVerificationMessageObserver = new MutationObserver(() => {
      const successVerificationText = emailVerificationMessage === null || emailVerificationMessage === void 0 ? void 0 : emailVerificationMessage.textContent;
      const bottomSectionFields = {
        accountType: document.querySelector('.accountType_li'),
        jobTitle: document.querySelector('.jobTitle_li'),
        newPassword: document.querySelector('.newPassword_li'),
        confirmNewPassword: document.querySelector('.reenterPassword_li'),
        termsAndConditionMandatory: document.querySelector('.extension_termsOfUseConsentChoice_li'),
        additionalTermsAndConditionMandatory: document.querySelector('.extension_termsOfUseConsentChoiceSecond_li'),
        termsAndConditionOptional: document.querySelector('.extension_newsletterConsentChoice_li'),
        continueButton: document.querySelector('.buttons #continue')
      };
      if (emailVerificationMessage.style.display === 'none' || emailVerificationMessage.style.display !== 'none' && !(successVerificationText === null || successVerificationText === void 0 ? void 0 : successVerificationText.includes('The code has been verified. You can now continue.'))) {
        for (const fields in bottomSectionFields) {
          const fieldHTMLElement = bottomSectionFields[fields];
          if (fieldHTMLElement) {
            fieldHTMLElement.style.display = 'none';
          }
        }
      } else if (emailVerificationMessage.style.display !== 'none' && (successVerificationText === null || successVerificationText === void 0 ? void 0 : successVerificationText.includes('The code has been verified. You can now continue.'))) {
        for (const fields in bottomSectionFields) {
          const fieldHTMLElement = bottomSectionFields[fields];
          if (fieldHTMLElement) {
            fieldHTMLElement.style.display = 'block';
          }
        }
      }
    });
    emailVerificationMessageObserver.observe(emailVerificationMessage, {
      attributes: true,
      childList: true,
      characterData: true
    });
  }
};
const sendVerificationCode = () => {
  const sendVerificationCodeButton = document.getElementById('emailViaMarketoVerificationControl_but_send_code');
  if (sendVerificationCodeButton) {
    sendVerificationCodeButton.click();
  }
};
const initForm = () => {
  (0, login_1.removeLoginClickListener)();
  if ((0, cookieBanner_1.shouldAddCookieConsentBanner)()) {
    (0, cookieBanner_1.addCookieConsentBanner)();
  }
  sendVerificationCode();
  fixTabIndexes();
  styleFederatedExchangeButton();
  styleAccountTypeRadioButtons();
  (0, smartlook_1.initPrivacy)();
  (0, sanitizer_1.enableFormSanitization)();
  styleSecondStepOfRegistrationPage();
  if (!isForgotPasswordPage() && !isRegistrationPage()) {
    (0, login_1.addLoginClickListener)();
    (0, login_1.attachLoggedInEventListener)();
  }
  if (isForgotPasswordPage()) {
    // new password fields will be displayed back after verification code is verified successfully
    (0, forgotPassword_1.showNewPasswordFields)(false);
    const continueButton = document.getElementById('continue');
    if (continueButton) {
      continueButton.style.display = 'none';
    }
  }
  if (isRegistrationPage() && isFinalStepOfRegistration()) {
    useCustomerAccountType();
    adjustAgreeOption();
    styleEmailVerificationLabel();
  }
  if (isRegistrationPage()) {
    fixCountryCodeStyle();
    randomizeUserRoles();
    (0, usStates_1.initUsStateLogic)();
  }
  if (isVerifyEmailAddress()) {
    const emailVerifyButtonContainer = emailVerificationContent === null || emailVerificationContent === void 0 ? void 0 : emailVerificationContent.querySelector('.buttons');
    const emailVerifyContinueButton = emailVerifyButtonContainer === null || emailVerifyButtonContainer === void 0 ? void 0 : emailVerifyButtonContainer.querySelector('#emailVerificationControl_but_send_code');
    document.head.appendChild(script);
    emailVerifyContinueButton === null || emailVerifyContinueButton === void 0 ? void 0 : emailVerifyContinueButton.setAttribute('disabled', 'true');
    if (emailVerificationContent && emailVerifyButtonContainer && emailVerifyContinueButton) {
      (0, captchaCode_1.addCaptcha)(emailVerificationContent, emailVerifyButtonContainer, emailVerifyContinueButton);
    }
  }
  const emailFieldObserver = new MutationObserver(() => {
    if (emailField) {
      const style = getComputedStyle(emailField);
      const displayProps = style.getPropertyValue('display');
      if (displayProps === 'none') {
        const captchaBlock = document.querySelector('.cf-turnstile');
        if (emailVerificationContent === null || emailVerificationContent === void 0 ? void 0 : emailVerificationContent.contains(captchaBlock)) {
          emailVerificationContent.removeChild(captchaBlock);
        }
        if (document.head.contains(script)) {
          document.head.removeChild(script);
        }
      }
    }
  });
  if (emailField) emailFieldObserver.observe(emailField, {
    attributes: true,
    childList: true
  });
  if (isRegistrationPage() && isFinalStepOfRegistration()) {
    (0, login_1.addLoginNewAccountListener)();
  }
};
exports.initForm = initForm;
//# sourceMappingURL=init.js.map